
import { defineComponent } from 'vue'
import { formatSize, parseTime, formatLastTime } from '@remote/utils'
import { mapState, mapGetters, useStore } from 'vuex'
import { USER_DOWNLOAD_URL } from '@remote/constant'
import MeetIcon from '@remote/assets/img/meet-download-icon@3x.svg'
import SpeedTackIcon from '@remote/assets/img/speed-tack-icon@3x.png'
import debounce from 'lodash/debounce'
import { useBTResult } from '@remote/store/hezi-file/bt-result'
import { getFileIconUrl, isVideoFile } from '@remote/utils/file-helper'
import { previewFile } from '@remote/store/hezi-file'
import { IFile } from '@remote/type/hezi'
import { toast } from '@remote/utils/dialog'

const statusMap = ['文件不存在', '下载完成', '等待中', '下载中...', '下载已暂停', '下载失败']
const STATUS_COMPELETED = 1

export default defineComponent({
  name: 'FileItem',
  props: {
    id: {
      type: String,
      require: true,
      default: '',
    },
  },
  setup () {
    return {
      store: useStore(),
      btResult: useBTResult(),
    }
  },
  data () {
    return {
      iShowHuddle: true,
      MeetIcon,
      SpeedTackIcon,
    }
  },
  computed: {
    ...mapState(['all', 'isSelect', 'taskType', 'tasks', 'huddleNum', 'teamTaskId', 'showLastCount', 'parentIds', 'isMiniProgram']),
    ...mapGetters(['curList', 'isVip', 'vipType', 'runningList', 'isYSvip', 'showVip', 'appCanPlay']),
    file (): IFile {
      return this.btResult.data.all[this.id]
    },
    phase (): string {
      return this.file.phase
    },
    spec (): string {
      const spec = (this.file.params.spec || '')?.match(/(delete|pause|running)/)
      return spec && this.phase !== 'PHASE_TYPE_ERROR' ? spec[0] : ''
    },
    size (): string | number {
      // if (!this.file.is_exist) return '文件不存在'
      if (this.taskType === 'file' && this.file.kind === 'drive#folder') return ''
      return this.file.size && this.file.size !== '0' ? formatSize(this.file.size || Number(this.file.size)) : ''
    },
    iconLink () {
      return this.file.icon_url || this.file.icon_link || getFileIconUrl(this.file.name)
    },
    status () {
      if (this.file.status === 1 && !this.file.is_exist) return '文件不存在'
      return statusMap[this.file.status]
    },
    videoDuration () {
      return this.file?.video_duration ? formatLastTime(this.file.video_duration) : ''
    },
    downloading () {
      return this.file.status === 3 ? 'downloading' : ''
    },
    isVideo () {
      return isVideoFile(this.file.name)
    },
  },
  watch: {
    phase (val, oVal) {
      if (val !== oVal && val === 'PHASE_TYPE_RUNNING' && this.huddleNum > 0 && this.file.type === USER_DOWNLOAD_URL && !this.isYSvip) {
        setTimeout(() => this.store.dispatch('checkHuddle', this.file), 1000)
      }
    },
  },
  methods: {
    parseTime,
    formatSize,
    handleSelect: debounce(async function (e) {
      if (this.file.status === STATUS_COMPELETED && this.file.is_exist) {
        previewFile(this.file)
      } else {
        toast({type: 'error', message: '任务未下载完成，请稍后重试！'})
      }
    }, 500, {
      leading: true,
      trailing: false,
    }),
  },
})
